import { NgModule, ModuleWithProviders } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MdInputModule, MdIconModule, MdAutocompleteModule, MdChipsModule, MdChip } from '@angular/material';

import { TdChipsComponent } from './chips.component';
export { TdChipsComponent } from './chips.component';
export class QuiverChipsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MdInputModule,
        MdIconModule,
        MdChipsModule,
        MdAutocompleteModule
    ],
    declarations: [
        TdChipsComponent
    ],
    exports: [
        TdChipsComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverChipsModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverChipsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverChipsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
